import { ReactComponent as CopiedIcon } from 'assett/icons/copied.svg';
import { ReactComponent as CopyIcon } from 'assett/icons/copy.svg';
import { useEffect, useState } from 'react';
import Tooltip from 'styles/tooltip/Tooltip';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { copyToClipboard } from 'utils/utils';

interface ICopyButton {
	text: string;
}

const CopyButton = ({ text }: ICopyButton) => {
	const [isCopied, setIsCopied] = useState<boolean>(false);
	const [isDisplayedCopied, setIsDisplayedCopied] = useState<boolean>(false);
	const [isHover, setIsHover] = useState<boolean>(false);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const onCopy = () => {
		copyToClipboard(text);
		setIsCopied(true);
		setIsHover(false);

		setTimeout(() => {
			setIsCopied(false);
		}, 2000);
	};

	useEffect(() => {
		setIsDisplayedCopied(isCopied);
	}, [isCopied]);

	return (
		<Tooltip
			title={
				isCopied || isHover
					? tClientLabels(isCopied ? 'claim.tooltip.copied' : 'claim.tooltip.copyId')
					: ''
			}
			placement="right"
			open={isCopied || isHover}
		>
			{isCopied ? (
				<CopiedIcon
					style={{
						opacity: isDisplayedCopied ? 1 : 0,
						transition: 'opacity 0.2s ease-in-out',
					}}
				/>
			) : (
				<CopyIcon
					cursor={'pointer'}
					onClick={onCopy}
					style={{
						opacity: !isDisplayedCopied ? 1 : 0,
						transition: 'opacity 0.2s ease-in-out',
					}}
					onMouseOver={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
				/>
			)}
		</Tooltip>
	);
};

export default CopyButton;
